import * as zod from 'zod'

import { parseCurrencyInputToNumber } from '@/utils/currency'

type IssuePath = (string | number)[]

interface ValidateRequiredFieldParams {
  ctx: zod.RefinementCtx
  value: string
  path: IssuePath
  message: string
}

interface ValidateCurrencyFieldParams {
  ctx: zod.RefinementCtx
  value: string
  path: IssuePath
  requiredMessage: string
  invalidMessage: string
}

interface ValidateContactPhonesParams {
  ctx: zod.RefinementCtx
  contacts: Array<{ phone: string }>
  requiredMessage: string
  invalidMessage: string
}

// Telefones brasileiros completos têm 10 (fixo) ou 11 (celular) dígitos, incluindo o DDD.
function isCompletePhone(phone: string): boolean {
  const digits = phone.replace(/\D/g, '')
  return digits.length === 10 || digits.length === 11
}

function addCustomIssue(ctx: zod.RefinementCtx, path: IssuePath, message: string) {
  ctx.addIssue({
    code: 'custom',
    path,
    message
  })
}

function validateRequiredField({ ctx, value, path, message }: ValidateRequiredFieldParams) {
  if (value) return
  addCustomIssue(ctx, path, message)
}

function validateCurrencyField({ ctx, value, path, requiredMessage, invalidMessage }: ValidateCurrencyFieldParams) {
  if (!value) {
    addCustomIssue(ctx, path, requiredMessage)
    return
  }

  if (parseCurrencyInputToNumber(value) !== null) return
  addCustomIssue(ctx, path, invalidMessage)
}

function validateContactPhones({ ctx, contacts, requiredMessage, invalidMessage }: ValidateContactPhonesParams) {
  if (contacts.length === 0) {
    addCustomIssue(ctx, ['contacts', 0, 'phone'], requiredMessage)
    return
  }

  contacts.forEach((contact, index) => {
    if (!contact.phone) {
      addCustomIssue(ctx, ['contacts', index, 'phone'], requiredMessage)
      return
    }
    if (isCompletePhone(contact.phone)) return
    addCustomIssue(ctx, ['contacts', index, 'phone'], invalidMessage)
  })
}

export { validateContactPhones, validateCurrencyField, validateRequiredField }
